<pbc-filter [config]="ObjektNutzungsFilterConfig" [filter]="objektNutzungs.filter$ | async" (filterChange)="objektNutzungs.filter$.next($event)"></pbc-filter>
